export default {
  path: '/group-order',
  meta: {
    title: '订货订单',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/group-order`),
}



// WEBPACK FOOTER //
// ./src/views/GroupOrderList/router.js